import React from "react";
import { Tooltip } from 'antd';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { LAB_COLOR } from "../../constants/color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlask } from "@fortawesome/free-solid-svg-icons";
import { URL_LAB } from "../../constants/urls";
import LabResultsModal from "../lab-latex/LabResultsModal"
import _ from "lodash";
import { dateTimeToHumanString, dateTimeToString, getLabResultColor, toFixed } from "../../frameworks/Util";

export default function LabSkimList() {
  const [ target, setTarget ] = React.useState(null);
  const tableRef = React.useRef(null);

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {!original.lab_user && <Tooltip triger='hover' title={"ส่งผลแล็บ"}>
              <ColorButton 
                type='primary'
                override={LAB_COLOR}
                icon={<FontAwesomeIcon icon={faFlask}/>}
                onClick={()=> setTarget(original)} 
              />
            </Tooltip>}
          </div>
      )}
    },
    {
      title: 'เลขที่ Order',
      dataIndex: 'code',
      key: 'code',
      searcher: true,
    },
    {
      title: 'วันที่',
      dataIndex: 'created',
      key: 'created',
      render : (value) => value ? dateTimeToHumanString(value) : '-'
    },
    {
      title: 'ผลแล็บ',
      dataIndex: '',
      key: 'results',
      render: (value, original) => {
        return _.get(original, "results", "-").map((item) => {
          return (
            <div style={{ color: getLabResultColor(_.get(item, 'status', null)) }}>
              <Tooltip title={item.note}>{item.chemical} : {toFixed(item.amount, 3)}</Tooltip>
            </div>
          );
        });
      },
    },
  ]

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return(
    <>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_LAB.LAB_ORDER}
        params={{type : 'skim'}}
      />
      <LabResultsModal
        open={target ? true : false}
        onClose={() => {
          setTarget(null)
        }}
        target={target}
        onUpdate={() => {
          setTarget(null)
          refreshData();
        }}
      />
    </>
  )
}